import type { Json } from '../api/types';
import { diffLeaves } from '../workspace/paths';

export function formatValue(v: unknown): string {
  if (v === undefined) return '—';
  if (v === null) return 'null';
  if (typeof v === 'string') return JSON.stringify(v);
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
}

/** One row per changed leaf path: before → after (spec section 2.2). */
export function DiffView({ before, after, emptyMessage = 'No field changed.' }: { before: Json | undefined; after: Json | undefined; emptyMessage?: string }) {
  const rows = diffLeaves(before, after);
  if (rows.length === 0) return <p className="muted">{emptyMessage}</p>;
  return (
    <table className="diff">
      <thead>
        <tr>
          <th scope="col">Field</th>
          <th scope="col">Before</th>
          <th scope="col">After</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.path}>
            <th scope="row">{r.path}</th>
            <td className="diff-before">{formatValue(r.before)}</td>
            <td className="diff-after">{formatValue(r.after)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
